export default __webpack_public_path__ + "static/media/2226.b753d8b3.png";